// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PackageTabA_contentContainer__1-beP","imageContainer":"PackageTabA_imageContainer__2XFUW","image":"PackageTabA_image__2wZkk"};